/** @format */
import _ from "lodash";
import dayjs from "dayjs";

const propertyName = (property) => property.externalName || property.name;

const spaceSqFt = (s) => s.remeasured_space_available || s.space_available;
const spaceMaxSqFt = (s) =>
  Math.max(_.toNumber(s.maximum_contiguous), spaceSqFt(s));

// TODO - use this instead of formatNumberWithCommas (and can we use Intl.NumberFormat in all browsers now?)
const numberWithCommas = (x) => {
  if (window.Intl && Intl.NumberFormat) return Intl.NumberFormat().format(x);
  // Fallback for old browsers (iOS 9.3 doesn't have Intl)
  if (x === undefined || x === null || isNaN(x)) return x;
  let parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};

const formatSqFt = (sqft) => {
  if (!Number.isNaN(sqft)) {
    sqft = numberWithCommas(sqft);
    return `${sqft} sq ft`;
  } else return sqft;
};

const formatSpaceSqFt = (space) => formatSqFt(spaceSqFt(space));

const formatPropertyMaxSqFt = (property) => {
  return formatSqFt(
    Math.max(
      ...property.availableSpaces.map((s) =>
        Number.isNaN(spaceMaxSqFt(s)) ? 0 : spaceMaxSqFt(s),
      ),
    ),
  );
};

const formatPhone = (phone) => {
  if (!phone) return phone;
  let number = phone.CountryPrefix
    ? `${phone.CountryPrefix} ${phone.Number}`
    : phone.Number || phone;
  const orig = number;

  //normalize string and remove all unnecessary characters
  number = number.replace(/[^+\d]/g, "");

  const matcherUS = /^(?:\+?1)?(\d{3})(\d{3})(\d{4})$/;

  if (number.match(matcherUS)) {
    //reformat and return US/CA phone number
    return number.replace(matcherUS, "($1) $2-$3"); // Probably no need to include +1 here
  }

  return orig.replace(/\./g, "-").trim(); // If we don't get a match, just use whatever came in, but without dots because dots are wrong.
};

const formatAvailableMonth = (dateStr) => dayjs(dateStr).format("MMMM YYYY");

const roundDistance = (d) => {
  if (d === null || d === undefined || Number.isNaN(d)) return null;
  let r;
  if (d <= 0.8) return "Less than a mile away";
  if (d < 4) {
    r = Math.round(d, 1);
    if (r === 1.0) return "1 mile away";
  } else r = Math.round(d);
  return `${r} miles away`;
};

// It looks like this change to dashed URLs works for Google

const slugForSearch = (str) =>
  str.replace(/\W+/g, "-").toLowerCase().replace(/-usa$/, "");

const searchUrl = (str) =>
  `/search/${slugForSearch(str)}/medical-office-space-for-lease`;

const absoluteUrl = (url) => {
  if (!process.env.REACT_APP_BASE_URL) {
    throw Error("REACT_APP_BASE_URL undefined");
  }
  if (url.startsWith(process.env.REACT_APP_BASE_URL)) {
    return url;
  } else {
    return `${process.env.REACT_APP_BASE_URL}${url}`;
  }
};
const propertyUrl = (p) => {
  if (typeof p === "string") {
    // A few places (like redirects) don't have a property object and only have a propertyId string
    return `/${p}`;
  } else {
    //const search = searchUrl(`${p.city.name}, ${p.state}`);
    // Old long SEO version return `${search}/${p.wtweb_id}`;
    // New (and 2018 original) short version
    return `/${p.wtweb_id}`;
  }
};

/**
 * @deprecated Use Chakra breakpoints for any responsive display, remove this check entirely.
 */
const smallOriOS = (screenIsSmall) =>
  !!(navigator &&
    navigator.userAgent &&
    (navigator.userAgent.includes("iPhone") ||
      navigator.userAgent.includes("iPad")));

const metaDescription = (params = {}) => {
  if (!!params.q) {
    return `Find the perfect medical office for lease in the ${params.q} area today. Our healthcare real estate portfolio offers a choice of location and price.`;
  }
  if (!!params.city && !!params.state) {
    return `Find the perfect medical office for lease in the ${params.city}, ${params.state} area today. Our healthcare real estate portfolio offers a choice of location and price.`;
  }
  return `Find the perfect medical office for lease today. Our extensive healthcare real estate portfolio offers a variety of location and price options.`;
};

export default function decodeHtmlEntities(str) {
  if (typeof window === "undefined") {
    return str;
  }
  const el = document.createElement("textarea");
  el.innerHTML = str;
  return el.value;
}

export {
  formatAvailableMonth,
  formatPhone,
  formatPropertyMaxSqFt,
  formatSpaceSqFt,
  metaDescription,
  propertyName,
  propertyUrl,
  absoluteUrl,
  roundDistance,
  searchUrl,
  smallOriOS,
  numberWithCommas,
  spaceSqFt,
};
